import { Moment } from 'moment';
import { Severity } from '../../../../common/enums/Severity';
import { InventoryRecap } from '../../../../common/inventory/models/InventoryRecap';
import { Profile } from '../../../../common/models/Profile';
import { Issue } from './valueObjects/Issue';

export class ProjectPrintData {
  private issueGroups: Record<Severity, Issue[]>;

  constructor(
    private readonly name: string,
    private readonly description: string | null,
    private readonly lastAnalysis: Moment | null,
    private readonly defaultProfile: Profile | null,
    private readonly issues: Issue[] | null,
    private readonly inventory: InventoryRecap | null,
    private readonly organizationName: string
  ) {
    this.issueGroups = {
      [Severity.HIGH]: [],
      [Severity.MED]: [],
      [Severity.LOW]: [],
      [Severity.PASSED]: [],
      [Severity.FILTERED]: [],
      [Severity.DISABLED]: [],
      [Severity.NA]: [],
      [Severity.NO_WARNING]: [],
    };
    for (const issue of this.issues ?? []) {
      this.issueGroups[issue.getSeverity()].push(issue);
    }
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getLastAnalysis() {
    return this.lastAnalysis;
  }

  getDefaultProfile() {
    return this.defaultProfile;
  }

  getInventory() {
    return this.inventory;
  }

  getOrganizationName() {
    return this.organizationName;
  }

  getIssueGroups() {
    return this.issueGroups;
  }

  hasPriorityIssues() {
    return [Severity.PASSED, Severity.LOW, Severity.MED, Severity.HIGH].some((s) => this.issueGroups[s].length > 0);
  }

  hasHiddenIssues() {
    return [Severity.DISABLED, Severity.FILTERED, Severity.NA, Severity.NO_WARNING].some((s) => this.issueGroups[s].length > 0);
  }
}
